import styled from '@emotion/styled';

import { tokens } from '@hotjar/hotsauce';

export const AllowanceStyles = {
  PlanTrafficCoverageWrapper: styled.div<{ withSkuDropdown?: boolean }>`
    align-items: center;
    display: flex;
    height: ${tokens.spacer.x2};
    padding: ${(props) => (props.withSkuDropdown ? `0 ${tokens.spacer.x2}` : 0)};
  `,
  FixedHeightAllowanceText: styled.span`
    ${tokens.text('body1')};

    display: flex;
    flex-direction: column;
    height: ${tokens.spacer.x5};
    justify-content: flex-end;
  `,
  FixedHeightCoverageWrapper: styled.span`
    height: ${tokens.spacer.x2};
  `,
};
